import React from 'react';

import { OsmMarker } from './osm_marker';

export class GmapsMarker extends OsmMarker {
  constructor(props) {
    super(props);
  }

  addListeners() {
    this.listeners
      .push(google.maps.event.addListener(this.entity, 'click', this.props.onClick));
    this.listeners
      .push(google.maps.event.addListener(this.entity, 'mouseover', this.handleMouseOver));
    this.listeners
      .push(google.maps.event.addListener(this.entity, 'mouseout', this.handleMouseOut));
  }

  removeListeners() {
    if (window.google && this.listeners) {
      this.listeners.forEach((listener) => {
        google.maps.event.removeListener(listener);
      });
    }
  }

  openInfoWindow() {
    this.infowindow && this.infowindow.open(this.props.map, this.entity);
  }

  closeInfoWindow() {
    this.infowindow && this.infowindow.close();
  }

  setEntity(options) {
    this.entity = new google.maps.Marker(options);
  }

  setInfoWindow() {
    this.infowindow = new google.maps.InfoWindow({
      content: this.props.infoWindowContent
    });
  }

  removeEntity() {
    this.entity.setMap(null);
    this.entity = null;
  }

  getOptions(props) {
    return {
      map: props.map,
      draggable: props.draggable,
      icon: props.icon,
      position: new google.maps.LatLng(props.lat, props.lng)
    };
  }

  setIcon() {
    this.entity.setOptions({icon: this.props.icon});
  }
}
